import { Box, styled } from '@mui/material';

export const SearchTerms = styled(Box)`
  padding: 5px 0 14px;
  margin-top: 10px;
  max-height: 190px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    padding-top: 10px;
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 10px;
  }
`;

export const ChipSpacer = styled(Box)`
  margin: 0 5px 5px 0;
  display: inline-block;
`;

export const ToggleExactMatch = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
